import React, {useEffect, useState} from "react";
import {Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import {useSelector} from "react-redux";
import axios from "axios";
import {toast} from "react-toastify";
import DateHelper from "../../../../primer/DateHelper/DateHelper";
import DateBox from "../../../../primer/DateBox";
import {checkPermission, isEmpty} from "../../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import BetterCheckBox from "../../../../common/BetterCheckBox";

const MassFetchTransfersModal = ({show, setShow, successCallback}) => {
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const transferReportRequestData = useSelector((state) => state.TRANSFERS.transferReportRequestData);
    const [requestData, setRequestData] = useState({
        date_from: moment().subtract(3, "days").format("DD/MM/YYYY"),
        date_to: moment().format("DD/MM/YYYY"),
    });
    const [loading, setLoading] = useState(false);

    const [autoFetch, setAutoFetch] = useState(false);

    const autoFetchPermission = checkPermission("custom-admin", []);

    useEffect(() => {
        if (autoFetchPermission) autoFetchStatus();
    }, [])

    useEffect(() => {
        if (show) {
            setRequestData({
                ...requestData,
                date_from: transferReportRequestData.date_from || requestData.date_from,
                date_to: transferReportRequestData.date_to || requestData.date_to,
            })
        }
    }, [show])

    const onMassFetch = () => {
        setLoading(true);
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/fetch-company-transfers-mydata`, {
            ...requestData,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                setShow(false);
                toast.success("Επιτυχής άντληση.");
                if (successCallback) successCallback();
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            setLoading(false);
        })
    }

    const autoFetchStatus = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/transfer-auto-fetch-status`, {
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") setAutoFetch(res.data.data);
        }).catch((err) => {
            console.log(err);
        })
    }

    const toggleAutoFetching = (autoFetch) => {
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/toggle-transfer-auto-fetch`, {
            autoFetch,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                toast.success(`Επιτυχής ${autoFetch ? "ενεργοποίηση" : "απενεργοποίηση"}.`);
                setAutoFetch(autoFetch);
            } else {
                toast.error(res.data.message);
            }
        }).catch((err) => {
            console.log(err);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        })
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "datebox") {
            if (moment(e).isValid()) {
                prepChange[name] = moment(e).format("DD/MM/YYYY");
            } else {
                prepChange[name] = "";
            }
        }
        setRequestData({...requestData, ...prepChange});
    }

    return (
        <Modal show={show} onHide={() => setShow(false)} backdrop={"static"} dialogClassName={"modal45PercentWidth"}>
            <Modal.Header closeButton>
                <Modal.Title>Μαζική Άντληση Διακινήσεων από myDATA</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row className={"mb-2"}>
                    <Col md={4}>
                        <DateHelper
                            dateFromAndToFunction={(from, to) => {
                                setRequestData({...requestData, date_from: from, date_to: to});
                            }}
                        />
                    </Col>
                    <Col md={4}>
                        <DateBox
                            name={"date_from"}
                            selected={isEmpty(requestData.date_from) ? moment().toDate() : moment(requestData.date_from, "DD/MM/YYYY").toDate()}
                            label={"Ημερομηνία από"}
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, "datebox", "date_from")}
                        />
                    </Col>
                    <Col md={4}>
                        <DateBox
                            name={"date_to"}
                            selected={isEmpty(requestData.date_to) ? moment().toDate() : moment(requestData.date_to, "DD/MM/YYYY").toDate()}
                            label={"Ημερομηνία έως"}
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, "datebox", "date_to")}
                        />
                    </Col>
                </Row>
                {autoFetchPermission && (
                    <Row>
                        <Col md={6}>
                            <BetterCheckBox
                                name={"autoFetch"}
                                className={"mt-2 mb-2"}
                                text={"Να γίνεται αυτόματη άντληση Δ.Α."}
                                checked={autoFetch}
                                onChange={(e) => toggleAutoFetching(e.target.checked)}
                            />
                        </Col>
                    </Row>
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-primary" onClick={() => setShow(false)} disabled={loading}>
                    Κλείσιμο
                </Button>
                <Button variant="primary" onClick={() => onMassFetch()} disabled={loading}>
                    Άντληση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MassFetchTransfersModal;
